//Extras
import { FaCheck, FaTimes } from "react-icons/fa";
import { main } from "../../../assets/coach-assets/constants/colors";
import { fontType } from "../../../assets/extras";
import { memo } from "react";
import { decomposeDate } from "../../../assets/validator";

const PassedClasses = ({ variables, setVariables, onContinue }) => {

    //Funcion que da la asistencia al jugador
    const asisted = (index) => {
        variables.passedClasses[index].asistio = true
        variables.passedClasses[index].checked = true
        setVariables(prev => ({
            ...prev
        }))
    }

    //Funcion que quita la asistencia al jugador
    const notAsisted = (index) => {
        variables.passedClasses[index].asistio = false
        variables.passedClasses[index].checked = true
        setVariables(prev => ({
            ...prev
        }))
    }

    return (
        <div>
            {variables.showPassedClasses && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backgroundColor: "rgba(0,0,0,0.5)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        zIndex: 1001
                    }}
                >
                    <div
                        style={{
                            backgroundColor: "white",
                            display: "flex",
                            flexDirection: "column",
                            width: "80%",
                            height: 400,
                            borderRadius: 20,
                            alignItems: "center",
                            padding: 20,
                            border: "1px solid black",
                            maxWidth: 500
                        }}
                    >
                        <p
                            style={{
                                fontFamily: fontType.title,
                                textAlign: "center",
                                width: "100%",
                                fontSize: 18,
                                backgroundColor: main,
                                padding: 10,
                                borderRadius: 10,
                                color: "white",
                                marginBottom: 20
                            }}
                        >
                            MARCA TUS CLASES MUESTRA
                        </p>

                        <div style={{ width: "100%", overflowY: "auto" }}>
                            {variables.passedClasses.map((item, index) => (
                                <div
                                    key={index}
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        flexDirection: "row",
                                        padding: "20px 10px",
                                        borderColor: main,
                                        borderWidth: 2,
                                        borderStyle: "solid",
                                        borderRadius: 10,
                                        marginBottom: 10
                                    }}
                                >
                                    <div style={{ width: "80%" }}>
                                        <p
                                            style={{
                                                fontWeight: "bold",
                                                fontSize: 15,
                                                marginBottom: 5,
                                                fontFamily: fontType.title
                                            }}
                                        >
                                            {item.nombre}
                                        </p>
                                        <p
                                            style={{
                                                fontWeight: "bold",
                                                fontSize: 12,
                                                marginBottom: 5,
                                                fontFamily: fontType.text
                                            }}
                                        >
                                            {decomposeDate(item.fecha_clase)}
                                        </p>
                                        <p
                                            style={{
                                                fontWeight: "bold",
                                                fontSize: 15,
                                                marginBottom: 5,
                                                fontFamily: fontType.text,
                                                marginTop: 20
                                            }}
                                        >
                                            {item.nombre_clase}
                                        </p>
                                        <input
                                            style={{
                                                fontSize: 16,
                                                width: "90%",
                                                borderWidth: 1,
                                                borderRadius: 6,
                                                border: "1px solid #bbb",
                                                color: "black",
                                                padding: 4
                                            }}
                                            placeholder="Comentarios"
                                            defaultValue={item.comentarios_clase}
                                            onChange={e => {
                                                const t = e.target.value;
                                                variables.passedClasses[index].comentarios_clase = t;
                                                setVariables(prev => ({ ...prev }));
                                            }}
                                        />
                                    </div>

                                    <div>
                                        {item.asistio === true ? (
                                            <button
                                                style={{
                                                    backgroundColor: "darkred",
                                                    borderRadius: 5,
                                                    padding: "6px 10px",
                                                    border: "none",
                                                    cursor: "pointer"
                                                }}
                                                onClick={() => notAsisted(index)}
                                            >
                                                <FaTimes size={20} color="white" />
                                            </button>
                                        ) : (
                                            <button
                                                style={{
                                                    backgroundColor: main,
                                                    borderRadius: 5,
                                                    padding: "6px 10px",
                                                    border: "none",
                                                    cursor: "pointer"
                                                }}
                                                onClick={() => asisted(index)}
                                            >
                                                <FaCheck size={20} color="white" />
                                            </button>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>

                        <button
                            style={{
                                backgroundColor: main,
                                marginTop: 10,
                                padding: "8px 16px",
                                borderRadius: 8,
                                border: "none",
                                cursor: "pointer",
                                width: 150,
                                height: 40
                            }}
                            onClick={() => onContinue()}
                        >
                            <span
                                style={{
                                    color: "white",
                                    fontSize: 16,
                                    fontFamily: fontType.title
                                }}
                            >
                                CONFIRMAR
                            </span>
                        </button>
                    </div>
                </div>
            )}
        </div>
    )
}

export default memo(PassedClasses)